<app-detail-page-shell
    [back]="back"
    testId="detail-page-demo">

    <app-detail-header detail-page-header
        [model]="headerModel">
    </app-detail-header>

    <app-detail-section title="Summary"
                        description="Aggregate metrics for this batch"
                        iconClass="fa-chart-bar">
        <app-detail-kpi-row [cards]="kpiCards"></app-detail-kpi-row>
    </app-detail-section>

    <app-detail-section title="Per-station efficiency"
                        description="Touch / Dwell / Standard for each station"
                        iconClass="fa-exchange-alt">
        <app-station-variance-table-batch
            [rows]="varianceRows"
            [entriesByStation]="entriesByStation"
            [expandedStations]="expandedStations"
            (stationToggled)="onStationToggled($event)"
            (entryEditClicked)="onEntryEditClicked($event)">
        </app-station-variance-table-batch>
    </app-detail-section>

    <app-detail-section title="Loading state"
                        description="What a section looks like while data is fetching"
                        state="loading">
    </app-detail-section>

    <app-detail-section title="Empty state"
                        description="What a section looks like with no data"
                        state="empty"
                        emptyMessage="No data for this view yet — try a different time range.">
    </app-detail-section>

    <app-detail-section title="Error state"
                        description="What a section looks like when the fetch fails"
                        state="error"
                        errorMessage="Failed to load — check the console.">
    </app-detail-section>

    <app-detail-section title="Collapsible section"
                        description="Click the header to collapse"
                        iconClass="fa-cog"
                        [collapsible]="true"
                        [collapsed]="true">
        <p>This panel was collapsed by default. Click the header to expand.</p>
    </app-detail-section>
</app-detail-page-shell>
